/* eslint-disable max-lines */
import { IntegrationKinds } from '@recruitee/integrations-types';

import type { AdpIntegration } from '../integrations/adp/types';
import type { AfasIntegration } from '../integrations/afas/types';
import type { AppicalIntegration } from '../integrations/appical/types';
import type { BambooIntegration } from '../integrations/bamboo/types';
import type { BryqIntegration } from '../integrations/bryq/types';
import type { CheckrIntegration } from '../integrations/checkr/types';
import type { CodilityIntegration } from '../integrations/codility/types';
import type { DevSkillerIntegration } from '../integrations/dev-skiller/types';
import type { DocuSignIntegration } from '../integrations/docu-sign/types';
import type { EnboarderIntegration } from '../integrations/enboarder/types';
import type { ESkillIntegration } from '../integrations/eskill/types';
import type { GfeaIntegration } from '../integrations/gfea/types';
import type { GustoIntegration } from '../integrations/gusto/types';
import type { HackerRankIntegration } from '../integrations/hacker-rank/types';
import type { HarverIntegration } from '../integrations/harver/types';
import type { HelloSignIntegration } from '../integrations/hello-sign/types';
import type { HibobIntegration } from '../integrations/hibob/types';
import type { HotelprofessionalsIntegration } from '../integrations/hotelprofessionals/types';
import type { Hr2dayIntegration } from '../integrations/hr2day/types';
import type { IndeedIntegration } from '../integrations/indeed/types';
import type { InterviewMochaIntegration } from '../integrations/interview-mocha/types';
import type { JacandoIntegration } from '../integrations/jacando/types';
import type { JitsiIntegration } from '../integrations/jitsi/types';
import type { JobCampaignsIntegration } from '../integrations/job-campaigns/types';
import type { KiwiHrIntegration } from '../integrations/kiwi-hr/types';
import type { KununuIntegration } from '../integrations/kununu/types';
import type { LuccaIntegration } from '../integrations/lucca/types';
import type { NmbrsIntegration } from '../integrations/nmbrs/types';
import type { OfficientIntegration } from '../integrations/officient/types';
import type { PartnerIntegration } from '../integrations/partner/types';
import type { PersonioIntegration } from '../integrations/personio/types';
import type { PredictiveIndexIntegration } from '../integrations/predictive-index/types';
import type { SignRequestIntegration } from '../integrations/sign-request/types';
import type { SympaIntegration } from '../integrations/sympa/types';
import type { TeamsIntegration } from '../integrations/teams/types';
import type { TestDomeIntegration } from '../integrations/test-dome/types';
import type { TyomarkkinatoriIntegration } from '../integrations/tyomarkkinatori/types';
import type { WerkenInEenHotelIntegration } from '../integrations/werken-in-een-hotel/types';
import type { ZoomIntegration } from '../integrations/zoom/types';

export const ALL_INTEGRATION_KINDS = [
  IntegrationKinds.ADP,
  IntegrationKinds.HR2DAY,
  IntegrationKinds.TYOMARKKINATORI,
  IntegrationKinds.HACKER_RANK,
  IntegrationKinds.JITSI,
  IntegrationKinds.DEV_SKILLER,
  IntegrationKinds.OFFICIENT,
  IntegrationKinds.ESKILL,
  IntegrationKinds.GUSTO,
  IntegrationKinds.KIWI_HR,
  IntegrationKinds.JACANDO,
  IntegrationKinds.KUNUNU,
  IntegrationKinds.TEAMS,
  IntegrationKinds.HARVER,
  IntegrationKinds.INDEED,
  IntegrationKinds.PREDICTIVE_INDEX,
  IntegrationKinds.DOCU_SIGN,
  IntegrationKinds.HELLO_SIGN,
  IntegrationKinds.SIGN_REQUEST,
  IntegrationKinds.GOOGLE_HANGOUTS_MEET,
  IntegrationKinds.ZOOM,
  IntegrationKinds.LUCCA,
  IntegrationKinds.NMBRS,
  IntegrationKinds.ENBOARDER,
  IntegrationKinds.HOTELPROFESSIONALS,
  IntegrationKinds.HIBOB,
  IntegrationKinds.WERKEN_IN_EEN_HOTEL,
  IntegrationKinds.APPICAL,
  IntegrationKinds.BRYQ,
  IntegrationKinds.INTERVIEW_MOCHA,
  IntegrationKinds.TEST_DOME,
  IntegrationKinds.CODILITY,
  IntegrationKinds.PERSONIO,
  IntegrationKinds.BAMBOO,
  IntegrationKinds.CHECKR,
];

export type IntegrationUnion =
  | PartnerIntegration
  | AdpIntegration
  | Hr2dayIntegration
  | TyomarkkinatoriIntegration
  | HackerRankIntegration
  | JitsiIntegration
  | DevSkillerIntegration
  | OfficientIntegration
  | ESkillIntegration
  | GustoIntegration
  | KiwiHrIntegration
  | JacandoIntegration
  | AfasIntegration
  | GfeaIntegration
  | SympaIntegration
  | KununuIntegration
  | JobCampaignsIntegration
  | TeamsIntegration
  | HarverIntegration
  | IndeedIntegration
  | PredictiveIndexIntegration
  | DocuSignIntegration
  | HelloSignIntegration
  | SignRequestIntegration
  | ZoomIntegration
  | LuccaIntegration
  | NmbrsIntegration
  | EnboarderIntegration
  | HotelprofessionalsIntegration
  | HibobIntegration
  | WerkenInEenHotelIntegration
  | AppicalIntegration
  | BryqIntegration
  | InterviewMochaIntegration
  | TestDomeIntegration
  | CodilityIntegration
  | PersonioIntegration
  | BambooIntegration
  | CheckrIntegration;
